import type { FC, ReactNode } from "react";
import { usePermissions } from "@/hooks/usePermissions";

type TPermissionGuardProps = {
  permissions: string[];
  children: ReactNode;
  fallback?: ReactNode;
  requireAll?: boolean;
};

/**
 * Simple wrapper component for permission-gated UI.
 * - Respects the admin bypass rules defined in usePermissions.
 * - Supports both "any" and "all" permission semantics.
 */
export const PermissionGuard: FC<TPermissionGuardProps> = ({
  permissions,
  children,
  fallback = null,
  requireAll = false,
}) => {
  const { hasPermission, hasAnyPermission } = usePermissions();

  const isAllowed = requireAll
    ? permissions.every((p) => hasPermission(p))
    : hasAnyPermission(permissions);

  return isAllowed ? <>{children}</> : <>{fallback}</>;
};
